"use strict";

const TouchscreenEmail = () => {
    const init = () => {
        if($('.js-touchscreen-email').length > 0) {
            $('input[type=text], input[type=password], textarea, input[type=textarea], input[type=email]').keyboard({
                usePreview: false,
                autoAccept: true,
                display: {
                  'bksp': " Backspace",
                  'accept': 'Enter',
                  'default': 'ABC',
                  'meta1': '.?123',
                  'meta2': '#+='
                },
            
                layout: 'custom',
                customLayout: {
                  'default': ['q w e r t y u i o p {bksp}',
                    '{bksp} a s d f g h j k l @',
                    '{s} z x c v b n m , .',
                    '{meta1} {space} {meta1} {accept}'
                  ],
                  'shift': ['Q W E R T Y U I O P {bksp}',
                    'A S D F G H J K L ',
                    '{s} Z X C V B N M ! ?',
                    '{meta1} {space} {meta1} {accept}'
                  ],
                  'meta1': ['1 2 3 4 5 6 7 8 9 0 {bksp}',
                    '- / : ; ( ) \u20ac & @ ',
                    '{meta2} . , ? ! \' " {meta2}',
                    '{default} {space} {default} {accept}'
                  ],
                  'meta2': ['[ ] { } # % ^ * + = {bksp}',
                    '_ \\ | ~ < > $ \u00a3 \u00a5 ',
                    '{meta1} . , ? ! \' " {meta1}',
                    '{default} {space} {default} {accept}'
                  ]
                }
            
            });
            
            $('#sidebar form input[type="text"], #sidebar form input[type="email"]').change(function(){
                gtag('event', 'CHANGED', {
                    'event_category': 'ENQUIRY', 
                    'event_label': 'Email Form - Changed '+$(this).attr('placeholder')
                });
            });
        }
    };

    return {
        init:init
    };
};

export default TouchscreenEmail;